import { render, staticRenderFns } from "./ksList.vue?vue&type=template&id=3f0ba389&"
import script from "./ksList.vue?vue&type=script&lang=js&"
export * from "./ksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports